import { render, staticRenderFns } from "./ShareSocialModal.vue?vue&type=template&id=0b021999&"
import script from "./ShareSocialModal.vue?vue&type=script&lang=js&"
export * from "./ShareSocialModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports